import React from 'react';

interface RequestEditalButtonProps {
  setRequestEdital: React.Dispatch<React.SetStateAction<boolean>>;
  requestEdital: boolean;
  solicited: boolean;
}

const SolicitationEditalButton = (props: RequestEditalButtonProps) => {
  const { setRequestEdital, requestEdital, solicited } = props;

  return (
    <button
      type="button"
      className={`btn ${solicited ? 'btn-secondary' : 'btn-primary'} btn-sm mr-1 mb-1`}
      disabled={solicited}
      onClick={() => setRequestEdital(!requestEdital)}
    >
      {solicited ? 'Edital solicitado' : 'Solicitar Edital'}
    </button>
  );
};

export default SolicitationEditalButton;
